"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.webConsolelogo = void 0;
function webConsolelogo(productName, applicationInfo) {
    var subStyle = "\npadding: .1em 0;\ncolor: rgb(98, 98, 108);\nfont-size: 2em;\nfont-weight: bold;\n".trim();
    var imageStyle = ("\ncolor: transparent;\ndisplay: inline-block;\nbackground-color: transparent;\nbackground-image: url('http://kibibit.io/kibibit-assets/1x/long-white.png');\nbackground-size: cover;\npadding: 0 " + 50 * 3.6 + "px 50px 0;\nborder: none;\nfont-size: 11px;\nline-height: 11px;\nfont-family: monospace;\n").trim();
    console.log("%ckibibit", imageStyle);
    console.log("%c" + productName, subStyle);
    console.groupCollapsed("application info");
    if (applicationInfo) {
        Array.isArray(applicationInfo)
            ? console.log(applicationInfo.join("\n") + "\n")
            : console.log(applicationInfo + "\n");
    }
    console.groupEnd();
}
exports.webConsolelogo = webConsolelogo;
//# sourceMappingURL=web.consologo.js.map